import React from "react";
import RunTabContent, { type RunTabBaseProps } from "./RunTabContent";

const CompleteRunsTab: React.FC<RunTabBaseProps> = (props) => {
  return <RunTabContent {...props} tabIndex={1} />;
};

export default CompleteRunsTab;
